import type { DeviceStats, Machine } from '../types';

/**
 * Trial-machine detection for the UI.
 *
 * A trial device ingests data via the trial endpoint with `site_id = serial_number`
 * (see Machine.get_effective_site_id on the backend). Once a machine is activated
 * its `site_id` becomes the assigned `site_name`, so it no longer matches a trial
 * serial and drops out of the trial view.
 *
 * We therefore treat a ServiceStats row as "trial" when its site_id matches the
 * serial_number of a Machine whose activation_status is 'trial'.
 */
export function trialSerialSet(machines: Machine[]): Set<string> {
  return new Set(
    machines
      .filter((m) => m.activation_status === 'trial')
      .map((m) => m.serial_number)
  );
}

export function isTrialStat(stat: DeviceStats, trialSerials: Set<string>): boolean {
  return trialSerials.has(stat.site_id);
}
